<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/icon-close.svg")
    h2.modal__title Отклонение заявки
    p.modal__text Вы уверены, что хотите отклонить заявку?
    .modal__button.modal__button--align-justify
      button.button.button_paint-main.button_full(
      @click="$emit('changeModalMode', modalData)"
      )
        .button__text Да
      button.button.button_paint-error.button_full(
      @click="$emit('close')"
      )
        .button__text Отмена

</template>

<script>
export default {
  name: "user-order",
  props: ["modalData"],
};
</script>
